<script setup lang="ts">

import {mergeProps, ref} from "vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import {CapacityFramework, Maintainer} from "@/types";
import {useAuth} from "@/composables/auth";

const {user} = useAuth();

interface Props {
    capacityFramework: CapacityFramework
    maintainer: Maintainer
}

const props = defineProps<Props>()

const emit = defineEmits<{
    (e: 'remove', userId: number): void;
}>();

const isRemoveMemberDialogOpen = ref<boolean>(false);
</script>

<template>
    <v-menu
        location="top end"
    >
        <template #activator="{ props: bind }">
            <v-tooltip
                location="top"
                content-class="bg-black border-sm text-tooltip"
                max-width="200"
            >
                <template #activator="{ props: subBind }">
                    <v-icon-btn
                        v-bind="mergeProps(bind, subBind)"
                        :disabled="maintainer.id === props.capacityFramework.user_id"
                        icon="mdi-dots-vertical"
                        size="32"
                        class="ml-2"
                        rounded="sm"
                    />
                </template>
                More actions
            </v-tooltip>
        </template>
        <v-list
            rounded="lg"
            border="sm"
            elevation="3"
            class="bg-background py-0 my-1"
            width="250"
        >
            <v-list-item
                v-if="props.maintainer.id !== props.capacityFramework.user_id"
                class="text-body-2 ma-1 pl-2 text-error"
                link
                density="compact"
                @click="isRemoveMemberDialogOpen = true"
            >
                {{ user.id !== props.maintainer.id ? 'Remove maintainer' : 'Leave framework' }}
            </v-list-item>
        </v-list>
    </v-menu>
    <delete-dialog
        v-model="isRemoveMemberDialogOpen"
        @submit="emit('remove', props.maintainer.id)"
    >
        <template #title>
            Remove maintainer
        </template>
        <template #default>
            Are you sure you want to {{ props.maintainer.name }} from "{{ props.capacityFramework.name }}"?
        </template>
        <template #label>
            Remove maintainer
        </template>
    </delete-dialog>
</template>

<style scoped>
:deep(.v-list-item__prepend) {
    width: 42px;
}

.v-list-item--density-compact.v-list-item--one-line {
    min-height: 32px;
}
</style>
